import * as Yup from 'yup'

const yupSegment = Yup.object().shape({
  formInput: Yup.object().shape({
    segmentName: Yup.string().required('Plese Enter Segment Name'),
  }),
})

export default yupSegment
